import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Popover, Row, Space, Tag } from "antd";
import { spacing } from "../../../../../styles/spacing.js";
/**
 * A functional component that displays a row of tags with a title.
 *
 * @param props - The props for the component, including tag options, flags and title.
 * @returns The rendered component.
 */ const TranslationTagsRow = (props)=>{
    const { tagOptions, flags, title } = props;
    const sortedFlags = [
        ...flags
    ].sort();
    return /*#__PURE__*/ _jsxs(Row, {
        hidden: !sortedFlags || sortedFlags.length === 0,
        style: {
            margin: spacing.layout.content.marginSmall
        },
        children: [
            /*#__PURE__*/ _jsxs(Col, {
                style: {
                    paddingRight: spacing.layout.content.paddingSmall
                },
                children: [
                    title,
                    ":"
                ]
            }),
            /*#__PURE__*/ _jsx(Col, {
                children: /*#__PURE__*/ _jsx(Space, {
                    size: [
                        8,
                        8
                    ],
                    wrap: true,
                    children: sortedFlags.map((flag)=>/*#__PURE__*/ _jsx(Tag, {
                            ...tagOptions,
                            children: flag
                        }, flag))
                })
            })
        ]
    });
};
/**
 * A functional component that displays a row of tags with a title and hover content.
 *
 * @param props - The props for the component, including tag options, flags and title.
 * @returns The rendered component.
 */ const TranslationTagsRowWithHover = (props)=>{
    const { tagOptions, flags, title } = props;
    const sortedFlags = [
        ...flags
    ].sort((a, b)=>a.text.localeCompare(b.text));
    return /*#__PURE__*/ _jsxs(Row, {
        hidden: !sortedFlags || sortedFlags.length === 0,
        style: {
            margin: spacing.layout.content.marginSmall
        },
        children: [
            /*#__PURE__*/ _jsxs(Col, {
                style: {
                    paddingRight: spacing.layout.content.paddingSmall
                },
                children: [
                    title,
                    ":"
                ]
            }),
            /*#__PURE__*/ _jsx(Col, {
                children: /*#__PURE__*/ _jsx(Space, {
                    size: [
                        8,
                        8
                    ],
                    wrap: true,
                    children: sortedFlags.map((flag)=>/*#__PURE__*/ _jsx(Popover, {
                            content: flag.hoverContent,
                            style: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ _jsx(Tag, {
                                ...tagOptions,
                                children: flag.text
                            })
                        }, flag.text))
                })
            })
        ]
    });
};
export { TranslationTagsRow, TranslationTagsRowWithHover };
